<div class="mt-1 h-100">
  <div class="container-fluid h-100 ">
    <div class="row flex-nowrap h-100" >
      <div class="col-md-12 ps-0">
        <section  class=" h-100">
          <div>
            <span class="fw-bold h4 ">
              <img src="../../../../assets/image.png" alt="" style="height: 20px;cursor: pointer;"
              (click)="gotobook()">
             <span style="font-size: 20px;"> {{'BookTourProperties'|translate}}</span>
            </span>
          </div>
          <section class="main_contant h-100">
            <div class="card rounded-4  card-rou" style=" border: 0.9px solid #D2D5DA !important;
            border-radius: 15px !important;
            background: #FFF !important;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25) !important; margin-top: 21px !important;">
              <div class="card-body  mat-typography h-100">
                <div class="row h-100">
                  <div class="col-md-6 mat-typography inner_card h-100" style="overflow-y: auto;">
                    <div class=" Card_bg_sky rounded-2" >
                      <div class="card-body d-flex grid gap-2">
                        <i class="fa-regular fa-circle-check fa-lg pt-1" style="color: #138615;"></i>
                        <p class="fs-5">{{'Your Request has been sent.' | translate}}</p>
                      </div>          
                    </div>
                    <mat-dialog-content class="mattypography pt-5" *ngFor="let props of properties">
                      <h3 class="mb-1" style="font-weight: 700;">{{'Properties' | translate}}:</h3>
                      <div class="row">
                        <div class="col-md-3 listing_img">
                          <img class="img-fluid images-flats" [src]="props.imagePathUrl ? props.imagePathUrl: 'https://weu-mlsp-dev-web.azurewebsites.net/assets/img/newDefaultImage.png'" alt="">
                        </div>
                        <div class="col-md-6">
                          <p class="fw-bold">{{props?.address}}</p>
                          <p class="text-muted "><b><i class="fa-regular fa-calendar pe-2"></i></b>{{ props.starttime | date:'EEEE dd, yyyy' }}</p>
                          <p class="text-muted"><b><i class="fa-regular fa-clock pe-2"></i></b>
                            <!-- {{ props.timeSlot }} -->
                            {{props?.starttime | date: 'shortTime' }} - {{
                              props?.endtime | date: 'shortTime' }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <div class="d-flex grid gap-2">
                            <span class="status-confirmed pt-2 rounded-2" [ngClass]="getStatusClasses(props.status)">{{ props.status }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 angent">
                          <p class="h6 pt-3">{{'Agent' | translate}}: <span class="sent_blue_color fs-6">{{ props.listingAgentName}}</span></p>
                        </div>
                        <div class="col-md-6 company">
                          <p class="h6 pt-3 ps-1">{{'Company' | translate}}: <span class="sent_blue_color fs-6">{{ props.companyName}}</span></p>
                        </div>
                      </div>
                      <hr class="fs-3">
                    </mat-dialog-content>
                  </div>
                  <div class="col-md-6">
                    <google-map class="static-map" width="100%" height="100%" [center]="center" [zoom]="zoom"
                      (mapClick)="moveMap($event)" (mapMousemove)="move($event)">
                      <map-directions-renderer *ngIf="optimizedRoute" [directions]="optimizedRoute" [options]="rendererOptions">
                      </map-directions-renderer>
                      <map-marker *ngFor="let waypoint of waypoints; let i = index" [position]="waypoint"
                        [label]="{ text: (i + 1).toString(), color: 'white', fontSize: '14px', fontWeight: 'bold' }"
                        [title]="'Waypoint ' + (i + 1)">
                      </map-marker>
                    </google-map>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div> 
  </div>
</div>